import { TestWrapper } from "./TestWrapper";

export function Test5() {
    return ( <TestWrapper number={4} />)
}